<template>
  <div>
    <div class="title mb-5">
      {{ $vuetify.lang.t("$vuetify.dashboard.title") }}
    </div>
    <v-row wrap>
      <!--  START SUMMARY    -->
      <v-col cols="12" sm="12">
        <v-card>
          <v-card-text>
            <v-row align-center>
              <v-col cols="12" sm="6">
                <v-list two-line>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="primary">mdi-clock-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 font-weight-bold"
                        >{{
                          $vuetify.lang.t("$vuetify.dashboard.filter.title")
                        }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        >{{
                          $vuetify.lang.t("$vuetify.dashboard.filter.title2")
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-right">
                  <v-btn
                    @click="showFilter"
                    class="my-6"
                    color="primary"
                    outlined
                    >{{
                      $vuetify.lang.t(
                        "$vuetify.dashboard.filter.title3",
                        [filter.createdAt.start],
                        [filter.createdAt.end]
                      )
                    }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="mx-auto white--text title"
            color="primary"
            height="153"
          >
            <v-card-title>
              <v-row wrap>
                <v-col cols="2">
                  <v-icon :size="hover ? 40 : 30" dark left>mdi-check</v-icon>
                </v-col>
                <v-col cols="10">
                  <div class="text-right">
                    <span class="display-1">{{ payment.success }}</span>
                  </div>
                  <div class="text-right subtitle-1">
                    {{
                      $vuetify.lang.t("$vuetify.dashboard.cols.success.title")
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card-title>
            <v-progress-linear
              :indeterminate="payment.loading"
              class="my-0"
              color="white"
              height="1"
            ></v-progress-linear>
            <v-divider light></v-divider>
            <v-card-actions>
              <span class="body-1">{{
                $vuetify.lang.t("$vuetify.dashboard.cols.success.title2")
              }}</span>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="4">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="mx-auto white--text title"
            color="secondary"
            height="153"
          >
            <v-card-title>
              <v-row wrap>
                <v-col cols="2">
                  <v-icon :size="hover ? 40 : 30" dark left>mdi-cancel</v-icon>
                </v-col>
                <v-col cols="10">
                  <div class="text-right">
                    <span class="display-1">{{ payment.cancel }}</span>
                  </div>
                  <div class="text-right subtitle-1">
                    {{
                      $vuetify.lang.t("$vuetify.dashboard.cols.cancel.title")
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card-title>
            <v-progress-linear
              :indeterminate="payment.loading"
              class="my-0"
              color="white"
              height="1"
            ></v-progress-linear>
            <v-divider light></v-divider>
            <v-card-actions>
              <span class="body-1">{{
                $vuetify.lang.t("$vuetify.dashboard.cols.cancel.title2")
              }}</span>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="4">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="mx-auto white--text title"
            color="primary"
            height="153"
          >
            <v-card-title>
              <v-row wrap>
                <v-col cols="2">
                  <v-icon :size="hover ? 40 : 30" dark left>mdi-cash</v-icon>
                </v-col>
                <v-col cols="10">
                  <div class="text-right">
                    <span class="display-1">{{ payment.amount }}</span>
                  </div>
                  <div class="text-right subtitle-1">
                    {{
                      $vuetify.lang.t("$vuetify.dashboard.cols.amount.title")
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card-title>
            <v-progress-linear
              :indeterminate="payment.loading"
              class="my-0"
              color="white"
              height="1"
            ></v-progress-linear>
            <v-divider light></v-divider>
            <v-card-actions>
              <div class="body-1">
                {{ $vuetify.lang.t("$vuetify.dashboard.cols.amount.title2") }}
              </div>
              <v-spacer></v-spacer>
              <div class="amount-description">
                <template
                  v-if="
                    $auth.check([
                      'ROLE_ADMIN',
                      'ROLE_COMMERCIAL',
                      'ROLE_COMPTA'
                    ])
                  "
                >
                  {{ _.round(payment.charges, 2) }}
                </template>
                <template v-else>
                  {{ _.round(payment.amount - payment.charges, 2) }}
                </template>
              </div>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="4">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="mx-auto white--text title"
            color="primary"
            height="153"
          >
            <v-card-title>
              <v-row wrap>
                <v-col cols="2">
                  <v-icon :size="hover ? 40 : 30" dark left>mdi-check</v-icon>
                </v-col>
                <v-col cols="10">
                  <div class="text-right">
                    <span class="display-1">{{ transfer.success }}</span>
                  </div>
                  <div class="text-right subtitle-1">
                    {{
                      $vuetify.lang.t("$vuetify.dashboard.cols.success.title3")
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card-title>
            <v-progress-linear
              :indeterminate="transfer.loading"
              class="my-0"
              color="white"
              height="1"
            ></v-progress-linear>
            <v-divider light></v-divider>
            <v-card-actions>
              <span class="body-1">{{
                $vuetify.lang.t("$vuetify.dashboard.cols.success.title4")
              }}</span>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="4">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="mx-auto white--text title"
            color="secondary"
            height="153"
          >
            <v-card-title>
              <v-row wrap>
                <v-col cols="2">
                  <v-icon :size="hover ? 40 : 30" dark left>mdi-cancel</v-icon>
                </v-col>
                <v-col cols="10">
                  <div class="text-right">
                    <span class="display-1">{{ transfer.cancel }}</span>
                  </div>
                  <div class="text-right subtitle-1">
                    {{
                      $vuetify.lang.t("$vuetify.dashboard.cols.cancel.title3")
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card-title>
            <v-progress-linear
              :indeterminate="transfer.loading"
              class="my-0"
              color="white"
              height="1"
            ></v-progress-linear>
            <v-divider light></v-divider>
            <v-card-actions>
              <span class="body-1">{{
                $vuetify.lang.t("$vuetify.dashboard.cols.cancel.title4")
              }}</span>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="4">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="mx-auto white--text title"
            color="primary"
            height="153"
          >
            <v-card-title>
              <v-row wrap>
                <v-col cols="2">
                  <v-icon :size="hover ? 40 : 30" dark left>mdi-cash</v-icon>
                </v-col>
                <v-col cols="10">
                  <div class="text-right">
                    <span class="display-1">{{ transfer.amount }}</span>
                  </div>
                  <div class="text-right subtitle-1">
                    {{
                      $vuetify.lang.t("$vuetify.dashboard.cols.amount.title3")
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card-title>
            <v-progress-linear
              :indeterminate="transfer.loading"
              class="my-0"
              color="white"
              height="1"
            ></v-progress-linear>
            <v-divider light></v-divider>
            <v-card-actions>
              <div class="body-1">
                {{ $vuetify.lang.t("$vuetify.dashboard.cols.amount.title4") }}
              </div>
              <v-spacer></v-spacer>
              <div class="amount-description">
                <template
                  v-if="
                    $auth.check([
                      'ROLE_ADMIN',
                      'ROLE_COMMERCIAL',
                      'ROLE_COMPTA'
                    ])
                  "
                >
                  {{ _.round(transfer.charges, 2) }}
                </template>
                <template v-else>
                  {{ _.round(transfer.amount + transfer.charges, 2) }}
                </template>
              </div>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
      <!--  END SUMMARY    -->

      <!--  START GRAPH    -->
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title class="heading">
            {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_1.title") }}
            <v-spacer></v-spacer>
            <v-menu bottom left v-if="!_.isEmpty(charts.chart_1.download.data)">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="download('png', 'chart_1')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.png") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('jpeg', 'chart_1')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.jpeg") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('excel', 'chart_1')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        $vuetify.lang.t("$vuetify.dashboard.btn.excel.title")
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text v-if="!_.isEmpty(charts.chart_1.download.data)">
            <g-chart
              :data="charts.chart_1.data"
              :options="charts.chart_1.options"
              @ready="onChartReady"
              id="chart_1"
              ref="chart_1"
              type="PieChart"
            >
            </g-chart>
          </v-card-text>
          <v-card-text v-else>
            <p class="font-weight-bold">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_1.title") }}
            </p>
            <h3 class="mt-12" style="height: 230px">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.no_data") }}
            </h3>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title class="heading">
            {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_2.title") }}
            <v-spacer></v-spacer>
            <v-menu bottom left v-if="!_.isEmpty(charts.chart_2.download.data)">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="download('png', 'chart_2')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.png") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('jpeg', 'chart_2')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.jpeg") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('excel', 'chart_2')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        $vuetify.lang.t("$vuetify.dashboard.btn.excel.title")
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text v-if="!_.isEmpty(charts.chart_2.download.data)">
            <g-chart
              :data="charts.chart_2.data"
              :options="charts.chart_2.options"
              @ready="onChartReady"
              id="chart_2"
              ref="chart_2"
              type="PieChart"
            >
            </g-chart>
          </v-card-text>
          <v-card-text v-else>
            <p class="font-weight-bold">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_2.title") }}
            </p>
            <h3 class="mt-12" style="height: 230px">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.no_data") }}
            </h3>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title class="heading">
            {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_4.title") }}
            <v-spacer></v-spacer>
            <v-menu bottom left v-if="!_.isEmpty(charts.chart_4.download.data)">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="download('png', 'chart_4')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.png") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('jpeg', 'chart_4')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.jpeg") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('excel', 'chart_4')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        $vuetify.lang.t("$vuetify.dashboard.btn.excel.title")
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text v-if="!_.isEmpty(charts.chart_4.download.data)">
            <g-chart
              :data="charts.chart_4.data"
              :options="charts.chart_4.options"
              @ready="onChartReady"
              id="chart_4"
              ref="chart_4"
              type="PieChart"
            >
            </g-chart>
          </v-card-text>
          <v-card-text v-else>
            <p class="font-weight-bold">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_4.title") }}
            </p>
            <h3 class="mt-12" style="height: 230px">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.no_data") }}
            </h3>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title class="heading">
            {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_5.title") }}
            <v-spacer></v-spacer>
            <v-menu bottom left v-if="!_.isEmpty(charts.chart_5.download.data)">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="download('png', 'chart_5')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.png") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('jpeg', 'chart_5')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.jpeg") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('excel', 'chart_5')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        $vuetify.lang.t("$vuetify.dashboard.btn.excel.title")
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text v-if="!_.isEmpty(charts.chart_5.download.data)">
            <g-chart
              :data="charts.chart_5.data"
              :options="charts.chart_5.options"
              @ready="onChartReady"
              id="chart_5"
              ref="chart_5"
              type="PieChart"
            >
            </g-chart>
          </v-card-text>
          <v-card-text v-else>
            <p class="font-weight-bold">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_5.title") }}
            </p>
            <h3 class="mt-12" style="height: 230px">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.no_data") }}
            </h3>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12">
        <v-card>
          <v-card-title class="heading">
            {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_3.title") }}
            <v-spacer></v-spacer>
            <v-menu bottom left v-if="!_.isEmpty(charts.chart_3.download.data)">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="download('png', 'chart_3')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.png") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('jpeg', 'chart_3')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.jpeg") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('excel', 'chart_3')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        $vuetify.lang.t("$vuetify.dashboard.btn.excel.title")
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text v-if="!_.isEmpty(charts.chart_3.download.data)">
            <g-chart
              :data="charts.chart_3.data"
              :options="charts.chart_3.options"
              @ready="onChartReady"
              id="chart_3"
              ref="chart_3"
              type="LineChart"
            >
            </g-chart>
          </v-card-text>
          <v-card-text v-else>
            <h2 class="mt-12" style="height: 230px">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.no_data") }}
            </h2>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12">
        <v-card>
          <v-card-title class="heading">
            {{ $vuetify.lang.t("$vuetify.dashboard.graphs.graph_6.title") }}
            <v-spacer></v-spacer>
            <v-menu bottom left v-if="!_.isEmpty(charts.chart_6.download.data)">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="download('png', 'chart_6')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.png") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('jpeg', 'chart_6')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $vuetify.lang.t("$vuetify.dashboard.btn.jpeg") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="download('excel', 'chart_6')">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        $vuetify.lang.t("$vuetify.dashboard.btn.excel.title")
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text v-if="!_.isEmpty(charts.chart_6.download.data)">
            <g-chart
              :data="charts.chart_6.data"
              :options="charts.chart_6.options"
              @ready="onChartReady"
              id="chart_6"
              ref="chart_6"
              type="LineChart"
            >
            </g-chart>
          </v-card-text>
          <v-card-text v-else>
            <h2 class="mt-12" style="height: 230px">
              {{ $vuetify.lang.t("$vuetify.dashboard.graphs.no_data") }}
            </h2>
          </v-card-text>
        </v-card>
      </v-col>
      <!--  END GRAPH    -->
    </v-row>
    <filter-form
      :dialog="dialog"
      @performFilter="performFilter"
      ref="filterForm"
    ></filter-form>
  </div>
</template>

<script>
import Statistic from "../../mixins/Common/Statistic";
import PathURL from "../../helpers/URL";
import Utils from "../../helpers/Utils";
import { GChart } from "vue-google-charts";
import { mapGetters } from "vuex";
import FilterForm from "./Filter";

export default {
  mixins: [Statistic],
  created() {
    this.urlItems = PathURL.PAYMENT.STATISTIC;
    this.urlItemsTransfer = PathURL.TRANSFER.STATISTIC;
    let date = new Date();
    date.setDate(date.getDate() - 30);
    this.filter.createdAt.start = date.toISOString().substr(0, 10);
    this.performFilter();
  },
  data: () => ({
    itemsPeriods: [],
    itemsApplications: [],
    itemsPaymentStatus: [],
    isLoading: false,
    loader: false,
    charts: {
      chart_1: {
        data: [
          ["Label", "Number"],
          ["", 0]
        ],
        options: {
          title: "",
          is3D: false,
          height: 350,
          legend: { position: "bottom" },
          fontSize: 11,
          titleTextStyle: {
            fontSize: 10,
            bold: false,
            italic: false
          },
          chartArea: {
            height: 250,
            width: 350
          },
          selectionMode: "multiple"
        },
        container: null,
        download: {
          data: []
        }
      },
      chart_2: {
        data: [
          ["Label", "Number"],
          ["", 0]
        ],
        options: {
          title: "",
          is3D: false,
          height: 350,
          legend: { position: "bottom" },
          fontSize: 11,
          titleTextStyle: {
            fontSize: 10,
            bold: false,
            italic: false
          },
          chartArea: {
            height: 250,
            width: 350
          },
          selectionMode: "multiple"
        },
        container: null,
        download: {
          data: []
        }
      },
      chart_3: {
        data: [
          ["Dates", "Nombre"],
          ["", 0]
        ],
        options: {
          chart: {
            title: ""
          },
          legend: { position: "top" },
          selectionMode: "multiple",
          fontSize: 13,
          hAxis: {
            title: "Dates",
            textStyle: {
              fontSize: 12 // or the number you want
            }
          },
          series: {
            0: { targetAxisIndex: 0 }
          },
          vAxes: {
            0: { title: "Montants" }
          },
          height: 350
        },
        container: null,
        download: {
          data: []
        }
      },
      chart_4: {
        data: [
          ["Label", "Number"],
          ["", 0]
        ],
        options: {
          title: "",
          is3D: false,
          height: 350,
          legend: { position: "bottom" },
          fontSize: 11,
          titleTextStyle: {
            fontSize: 10,
            bold: false,
            italic: false
          },
          chartArea: {
            height: 250,
            width: 350
          },
          selectionMode: "multiple"
        },
        container: null,
        download: {
          data: []
        }
      },
      chart_5: {
        data: [
          ["Label", "Number"],
          ["", 0]
        ],
        options: {
          title: "",
          is3D: false,
          height: 350,
          legend: { position: "bottom" },
          fontSize: 11,
          titleTextStyle: {
            fontSize: 10,
            bold: false,
            italic: false
          },
          chartArea: {
            height: 250,
            width: 350
          },
          selectionMode: "multiple"
        },
        container: null,
        download: {
          data: []
        }
      },
      chart_6: {
        data: [
          ["Dates", "Nombre"],
          ["", 0]
        ],
        options: {
          chart: {
            title: ""
          },
          legend: { position: "top" },
          selectionMode: "multiple",
          fontSize: 13,
          hAxis: {
            title: "Dates",
            textStyle: {
              fontSize: 12 // or the number you want
            }
          },
          series: {
            0: { targetAxisIndex: 0 }
          },
          vAxes: {
            0: { title: "Montants" }
          },
          height: 350
        },
        container: null,
        download: {
          data: []
        }
      }
    },
    dialog: {
      title: "$vuetify.dashboard.filter.title",
      show: false,
      saveBtnTitle: "$vuetify.btn.compile",
      action: "create",
      loadingBtn: false
    }
  }),
  methods: {
    onChartReady: function(chart) {
      switch (chart.container.id) {
        case "chart_1":
          this.charts.chart_1.container = chart.container;
          break;
        case "chart_2":
          this.charts.chart_2.container = chart.container;
          break;
        case "chart_3":
          this.charts.chart_3.container = chart.container;
          break;
        case "chart_4":
          this.charts.chart_4.container = chart.container;
          break;
        case "chart_5":
          this.charts.chart_5.container = chart.container;
          break;
        case "chart_6":
          this.charts.chart_6.container = chart.container;
          break;
      }
    },
    _getStatistic(type = "payment") {
      this.getStatistic(type)
        .then(() => {
          if (type === "payment") {
            let graphs = this._graphData(
              "p_status",
              this._groupBy("p_status"),
              type
            );
            this.charts.chart_1.data = graphs.graph;
            this.charts.chart_1.download.data = graphs.graphObj;
            graphs = this._graphData(
              "p_applicationName",
              this._groupBy("p_applicationName"),
              type
            );
            this.charts.chart_2.data = graphs.graph;
            this.charts.chart_2.download.data = graphs.graphObj;
            graphs = this._graphData_v2(
              "p_applicationName",
              this.response,
              null,
              type
            );
            this.charts.chart_3.data = graphs.graph;
            this.charts.chart_3.download.data = graphs.graphObj;
          } else {
            let graphs = this._graphData(
              "t_status",
              this._groupBy("t_status", type),
              type
            );
            this.charts.chart_4.data = graphs.graph;
            this.charts.chart_4.download.data = graphs.graphObj;
            graphs = this._graphData(
              "t_applicationName",
              this._groupBy("t_applicationName", type),
              type
            );
            this.charts.chart_5.data = graphs.graph;
            this.charts.chart_5.download.data = graphs.graphObj;

            graphs = this._graphData_v2(
              "t_applicationName",
              this.transferResponse,
              null,
              type
            );
            this.charts.chart_6.data = graphs.graph;
            this.charts.chart_6.download.data = graphs.graphObj;
          }
          if (this.$refs.dashboardForm) this.$refs.dashboardForm.closeDialog();
        })
        .finally(() => {});
    },
    _graphData(key, data, type = "payment") {
      let graph = [];
      let graphObj = [];
      let self = this;
      let labels = this._getLabels(key, data);
      let headers =
        type === "payment"
          ? [
              this.$vuetify.lang.t("$vuetify.dashboard.graphs.graph_1.x"),
              this.$vuetify.lang.t("$vuetify.dashboard.graphs.graph_1.y")
            ]
          : [
              this.$vuetify.lang.t("$vuetify.dashboard.graphs.graph_4.x"),
              this.$vuetify.lang.t("$vuetify.dashboard.graphs.graph_4.y")
            ];
      graph.push(headers);
      let filter = [];
      let sum = 0;
      let count = 0;
      let resp = [];
      let obj = {};
      const fieldTotal =
        type === "payment" ? "total_p_amount" : "total_t_amount";
      this._.forEach(labels, label => {
        filter = self._.filter(data, function(o) {
          return o[key] === label;
        });
        sum = self._.sumBy(filter, function(o) {
          return parseInt(o[fieldTotal]);
        });
        count = self._.sumBy(filter, function(o) {
          return parseInt(o.count);
        });
        obj[label] = count + " - " + sum + " FCFA";
        resp.push(label);
        resp.push(sum);
        sum = 0;
        sum = count;
        graph.push(resp);
        resp = [];
      });
      graphObj.push(obj);
      return { graph: graph, graphObj: graphObj };
    },
    _graphData_v2(key, data, status = null, type = "payment") {
      let graph = [];
      let graphObj = [];
      let self = this;
      let labels = this._getLabels(key, data, type);
      let dateLabel =
        type === "payment"
          ? this.$vuetify.lang.t("$vuetify.dashboard.graphs.graph_3.x")
          : this.$vuetify.lang.t("$vuetify.dashboard.graphs.graph_5.x");
      labels.unshift(dateLabel);
      graph.push(labels);

      const fieldTotal =
        type === "payment" ? "total_p_amount" : "total_t_amount";
      const fieldCreated = type === "payment" ? "p_createdAt" : "t_createdAt";
      const fieldStatus = type === "payment" ? "p_status" : "t_status";
      let dates = this._.uniq(this._getDates(data, fieldCreated));
      this._.forEach(dates, date => {
        let tempResp = [date];
        let obj = {};
        obj[dateLabel] = date;
        self._.forEach(labels, label => {
          if (dateLabel !== label) {
            let sum = 0;
            let filter = self._.filter(data, function(o) {
              return o[fieldCreated] === date && label === o[key];
            });
            if (status) {
              filter = self._.filter(filter, function(o) {
                return o[fieldStatus] === status;
              });
            }
            sum = self._.sumBy(filter, function(o) {
              return o[fieldTotal];
            });
            tempResp.push(sum);
            obj[label] = sum;
          }
        });
        graph.push(tempResp);
        graphObj.push(obj);
      });
      return { graph: graph, graphObj: graphObj };
    },
    _getDates(data, field = "p_createdAt") {
      let dates = [];
      this._.forEach(data, value => {
        dates.push(value[field]);
      });
      dates.sort((a, b) => new Date(a) - new Date(b));
      return dates;
    },
    download: function(type = "png", chartId) {
      let fileName = this.getFileName(chartId);
      if (type === "excel") {
        let title = fileName;
        let sheetName = "";
        sheetName = fileName;
        let datas = this.getDonwloadDataByChartId(chartId);
        Utils.saveAsExcell(datas, fileName, title, sheetName);
      } else {
        let container = this.getContainerByChartId(chartId);
        Utils.saveAsImage(container, type, fileName);
      }
    },
    getDonwloadDataByChartId: function(chartId) {
      switch (chartId) {
        case "chart_1":
          return this.charts.chart_1.download.data;
        case "chart_2":
          return this.charts.chart_2.download.data;
        case "chart_3":
          return this.charts.chart_3.download.data;
        case "chart_4":
          return this.charts.chart_4.download.data;
        case "chart_5":
          return this.charts.chart_5.download.data;
        case "chart_6":
          return this.charts.chart_6.download.data;
      }
      return [];
    },
    getContainerByChartId: function(chartId) {
      switch (chartId) {
        case "chart_1":
          return this.charts.chart_1.container;
        case "chart_2":
          return this.charts.chart_2.container;
        case "chart_3":
          return this.charts.chart_3.container;
        case "chart_4":
          return this.charts.chart_4.container;
        case "chart_5":
          return this.charts.chart_5.container;
        case "chart_6":
          return this.charts.chart_6.container;
      }
    },
    getFileName: function(chartId) {
      switch (chartId) {
        case "chart_1":
          return this.$vuetify.lang.t(
            "$vuetify.dashboard.graphs.graph_1.title"
          );
        case "chart_2":
          return this.$vuetify.lang.t(
            "$vuetify.dashboard.graphs.graph_2.title"
          );
        case "chart_3":
          return this.$vuetify.lang.t(
            "$vuetify.dashboard.graphs.graph_3.title"
          );
        case "chart_4":
          return this.$vuetify.lang.t(
            "$vuetify.dashboard.graphs.graph_4.title"
          );
        case "chart_5":
          return this.$vuetify.lang.t(
            "$vuetify.dashboard.graphs.graph_5.title"
          );
        case "chart_6":
          return this.$vuetify.lang.t(
            "$vuetify.dashboard.graphs.graph_6.title"
          );
      }
      return "";
    },
    _filterPayment() {
      let self = this;
      this.groups = ["p_applicationName", "p_status", "p_type"];
      this.getStatistic(false)
        .then(() => {
          const status = this.filter.status ? this.filter.status : null;
          let graphs = this._graphData_v2(
            "p_applicationName",
            this.response,
            status
          );
          this.charts.chart_3.data = graphs.graph;
          this.charts.chart_3.download.data = graphs.graphObj;
        })
        .finally(() => {
          self.loader = false;
        });
    },
    _filterTransfer() {
      let self = this;
      this.groups = ["t_applicationName", "t_status", "t_type"];
      this.getStatistic(false, "transfer")
        .then(() => {
          let graphs = this._graphData_v2(
            "t_applicationName",
            this.transferResponse,
            this.filter.status,
            "transfer"
          );
          this.charts.chart_6.data = graphs.graph;
          this.charts.chart_6.download.data = graphs.graphObj;
        })
        .finally(() => {
          self.loader = false;
        });
    },
    setItemPaymentStatus() {
      let self = this;
      this.paymentStatus.forEach(r => {
        self.itemsPaymentStatus.push({
          text: self.$vuetify.lang.t("$vuetify.paymentStatus." + r),
          value: r
        });
      });
    },
    showFilter() {
      this.$refs.filterForm.setForm(this.filter);
      this.dialog.show = true;
    },
    performFilter(data = null) {
      if (data) {
        this.filter.createdAt.start = data.createdAt.start;
        this.filter.createdAt.end = data.createdAt.end;
        this.filter.period = data.period;
        this.filter.user = data.user;
        this.filter.status = data.status;
        this.filter.transaction = data.transaction;
        this.filter.application = data.application;
      }
      this.period = this.filter.period;
      this.groups = ["p_applicationName", "p_status", "p_type"];
      this._getStatistic("payment");
      this.groups = ["t_applicationName", "t_status", "t_type"];
      this._getStatistic("transfer");
    }
  },
  computed: {
    ...mapGetters({
      periods: "user/periods",
      paymentStatus: "payment/status"
    })
  },
  components: {
    GChart,
    FilterForm
  }
};
</script>

<style scoped>
.amount-description {
  font-size: 1.4rem !important;
}
</style>
